




export const baseUrl="https://gw.mangolive.in"

// export const  baseUrl="/api"


// WEBPACK FOOTER //
// ./src/api/config.js